export enum EAppTermsModals {
  ADD_EDIT = 'add_edit',
  CONFIRM = 'confirm',
}

export enum EAppTermsModalAction {
  DELETE = 'delete',
}

export interface AppTermsModalPayload {
  action?: EAppTermsModalAction;
}

export interface IAppTermsModal {
  type: EAppTermsModals;
  payload?: AppTermsModalPayload;
}

export interface IAppTerm {
  id: number;
  title: string;
  content: string;
  position_index: number;
  updated_at: string;
}

export interface FetchTermsByCodePayload {
  invitation_code: string;
}

export interface CreateAppTermPayload {
  title: string;
  content: string;
}

export interface UpdateAppTermPayload extends CreateAppTermPayload {
  id: number;
}

export interface DeleteAppTermPayload {
  id: number;
}

export interface SaveTermsOrderPayload {
  order: {
    id: number;
    position_index: number;
  }[];
}
